<template>
  <div>
    <h3 class="u-mb-20">{{ id ? 'Editar unidade de medida' : 'Nova unidade de medida' }}</h3>

    <el-alert class="u-mb-20" type="info" :closable="false" show-icon
      title="O fator informa quanto vale 1 desta unidade na unidade base da grandeza (g para massa, ml para volume, un para contagem). A conversão só acontece dentro da mesma grandeza."></el-alert>

    <el-form :model="dados" ref="form" label-position="top">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="10">
          <el-form-item label="Nome" prop="nome">
            <el-input v-model="dados.nome" placeholder="Ex.: Quilograma"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="4">
          <el-form-item label="Sigla" prop="sigla">
            <el-input v-model="dados.sigla" placeholder="kg"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="10">
          <el-form-item label="Grandeza" prop="grandeza">
            <el-select v-model="dados.grandeza" placeholder="Selecione" style="width:100%">
              <el-option v-for="g in grandezas" :key="g" :label="g.toUpperCase()" :value="g"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :xs="24" :sm="8">
          <el-form-item :label="'Fator na base' + (dados.grandeza ? ' (' + baseDa(dados.grandeza) + ')' : '')" prop="fator_base">
            <el-input v-model="dados.fator_base" type="number" step="0.000001" placeholder="1000"></el-input>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="8">
          <el-form-item label="É a unidade base?">
            <el-switch v-model="dados.base"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :xs="24" :sm="8">
          <el-form-item label="Ativa">
            <el-switch v-model="dados.situacao"></el-switch>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="u-text-right u-mt-20">
        <router-link to="/admin/merenda/unidade-medida" class="u-mr-10">
          <el-button>CANCELAR</el-button>
        </router-link>
        <el-button type="primary" @click="salvar">SALVAR</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  data: () => ({
    id: null,
    grandezas: [],
    dados: { nome: '', sigla: '', grandeza: '', fator_base: '', base: false, situacao: true }
  }),
  mounted () {
    this.id = this.$route.params.id || null
    this.initForm()
    if (this.id) this.carregar()
  },
  methods: {
    baseDa (grandeza) {
      return { massa: 'g', volume: 'ml', contagem: 'un' }[grandeza] || ''
    },
    initForm () {
      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/merenda/unidade-medida/initForm`, this.$store.getters.getHeaderAuth)
        .then(response => { this.grandezas = response.data.grandezas })
        .catch((error) => { this.$store.commit('throwException', error) })
    },
    carregar () {
      window.eventBus.$emit('loading', true)
      this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/merenda/unidade-medida/getById/` + this.id, this.$store.getters.getHeaderAuth)
        .then(response => {
          window.eventBus.$emit('loading', false)
          if (response.data && response.data.erro) {
            return window.eventBus.$emit('alert', { msg: response.data.erro, type: 'warning' })
          }
          this.dados = response.data
        }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
    },
    salvar () {
      window.eventBus.$emit('loading', true)
      const url = this.id
        ? `${this.$store.state.config.baseUrlApi}/api/merenda/unidade-medida/update/` + this.id
        : `${this.$store.state.config.baseUrlApi}/api/merenda/unidade-medida/store`

      this.$axios.post(url, this.dados, this.$store.getters.getHeaderAuth)
        .then(response => {
          window.eventBus.$emit('loading', false)
          if (response.data && response.data.erro) {
            return window.eventBus.$emit('alert', { msg: response.data.erro, type: 'warning' })
          }
          window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
          this.$router.push('/admin/merenda/unidade-medida')
        }).catch((error) => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', error) })
    }
  }
}
</script>
